module.exports = __webpack_public_path__ + "img/ex-logo.928d500c.svg";